<div class="vcaas-help-widget flex flex-col items-end gap-2">
    <!-- Chooser menu (opens above the trigger) -->
    <div *ngIf="helpMenuOpen"
        class="flex flex-col items-stretch gap-1 w-64 sm:w-72 p-2 bg-white rounded-2xl border border-gray-100 shadow-xl">
        <!-- Schedule a call -->
        <button type="button" (click)="scheduleCall()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-slate-50 transition-colors text-left w-full">
            <span class="w-9 h-9 rounded-full bg-slate-900 text-white flex items-center justify-center flex-shrink-0">
                <i class="fa-solid fa-calendar-check text-sm"></i>
            </span>
            <span class="flex flex-col leading-tight min-w-0">
                <span class="text-sm font-semibold text-slate-900">{{ 'vcaas.scheduleCallOption' | translate }}</span>
                <span class="text-[11px] text-gray-400">{{ 'vcaas.scheduleCallOptionSub' | translate }}</span>
            </span>
        </button>
        <!-- Email us (+ copy) -->
        <div class="flex items-center gap-1 rounded-xl hover:bg-slate-50 transition-colors">
            <button type="button" (click)="emailUs()"
                class="flex-1 flex items-center gap-3 px-3 py-2.5 text-left min-w-0">
                <span class="w-9 h-9 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center flex-shrink-0">
                    <i class="fa-solid fa-envelope text-sm"></i>
                </span>
                <span class="flex flex-col leading-tight min-w-0">
                    <span class="text-sm font-semibold text-slate-900">{{ 'vcaas.emailUs' | translate }}</span>
                    <span class="text-[11px] text-gray-400 truncate">{{ contactEmail }}</span>
                </span>
            </button>
            <button type="button" (click)="copyEmail()"
                [title]="'vcaas.copyEmail' | translate"
                class="w-8 h-8 mr-1.5 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors"
                [ngClass]="emailCopied ? 'bg-green-50 text-green-600' : 'text-gray-400 hover:bg-gray-100 hover:text-gray-600'">
                <i class="fa-solid text-xs" [ngClass]="emailCopied ? 'fa-check' : 'fa-copy'"></i>
            </button>
        </div>
    </div>

    <!-- Trigger — bigger on desktop -->
    <button type="button" (click)="helpMenuOpen = !helpMenuOpen"
        class="flex items-center gap-2.5 sm:gap-3 rounded-full bg-slate-900 text-white pl-3 pr-4 py-2.5 sm:pl-4 sm:pr-5 sm:py-3.5 shadow-lg hover:bg-slate-800 transition-all">
        <span class="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
            <i class="fa-solid fa-headset text-sm sm:text-base"></i>
        </span>
        <span class="flex flex-col leading-tight text-left">
            <span class="text-xs sm:text-sm font-semibold">{{ 'vcaas.needHelp' | translate }}</span>
            <span class="text-[11px] sm:text-xs text-white/70">{{ 'vcaas.scheduleOrEmail' | translate }}</span>
        </span>
        <i class="fa-solid fa-chevron-up text-[10px] sm:text-xs text-white/50 transition-transform ml-0.5"
            [class.rotate-180]="helpMenuOpen"></i>
    </button>
</div>
